<div class="service-ticket-dialog">
  <mat-form-field>
    <input [(ngModel)]="title" matInput placeholder="{{'general.title' | translate}}" required>
  </mat-form-field>
  <mat-form-field class="description">
    <textarea [(ngModel)]="description" matInput placeholder="{{'general.descriptionOfProblem' | translate}}" required
              cdkTextareaAutosize cdkAutosizeMinRows="7" cdkAutosizeMaxRows="7"></textarea>
  </mat-form-field>
  <mat-checkbox [(ngModel)]="dataProtection" class="data-protection">
    Ich nehme zur Kenntnis, dass durch das Absenden der Anfrage im Serviceportal ein Profil erstellt wird, welches die Bearbeitung des Tickets erleichtert.
    Mehr über unser Ticketportal erfahren Sie in unserer <a href="https://ipeak.ch/datenschutz/#jira" target="_blank">Datenschutzerklärung</a>.
  </mat-checkbox>
  <div class="button-container">
    <button (click)="dialogRef.close()" class="ibexfusion-raised-button" mat-button>{{ 'general.close' | translate }}</button>
    <button (click)="save()" class="ibexfusion-raised-button" mat-button
    [disabled]="!title || !description || !dataProtection"
            [class.mat-button-disabled]="!title || !description || !dataProtection">{{ 'general.send' | translate }}</button>
  </div>
</div>
